import { DynamicDataTypeDescription } from 'controls/designer/features/widgets/textWidget/types';
import { dynamicValueTypeDescription } from 'controls/designer/features/widgets/textWidget/dynamic-data/datasource-value/dynamicValueTypeDescription';

const registry: DynamicDataTypeDescription[] = [dynamicValueTypeDescription];

export function getAllDynamicDataTypes(): DynamicDataTypeDescription[] {
	return registry;
}

export function getDynamicDataType(type: string): DynamicDataTypeDescription | undefined {
	return registry.find((d) => d.type === type);
}
